import { useFragment, graphql } from 'react-relay';

// types
import {
    type usePdpCreatorDetails_item$key as Item,
    type usePdpCreatorDetails_item$data as ItemData,
} from './__generated__/usePdpCreatorDetails_item.graphql.ts';

const itemFragment = graphql`
    fragment usePdpCreatorDetails_item on Item {
        storyTellingModule(shortTitles: true) {
            tabs {
                contentHeader
            }
        }
        pdpDetailsDisplay {
            detailKey
            detailValues {
                browseUrl
                detailKey
                displayName
                displayDetails
            }
        }
    }
`;

type CreatorDetailValue = NonNullable<
    NonNullable<
        NonNullable<NonNullable<ItemData['pdpDetailsDisplay']>[number]>['detailValues']
    >[number]
>;

type CreatorLinkMap = Record<string, string>;

const CREATOR = 'CREATOR';

export const usePdpCreatorDetails = ({
    item: itemRef,
}: {
    item: Item | null;
}): { uniqueCreators: CreatorDetailValue[]; creatorLinkMap: CreatorLinkMap } => {
    const item = useFragment(itemFragment, itemRef);

    const { pdpDetailsDisplay, storyTellingModule } = item || {};

    const creators = pdpDetailsDisplay?.find(detail => detail?.detailKey === CREATOR);

    const creatorLinkMap =
        creators?.detailValues?.reduce((a: CreatorLinkMap, b) => {
            const { displayName, browseUrl } = b || {};
            const name = displayName?.toLowerCase();

            if (name && browseUrl) {
                a[name] = browseUrl;
            }
            return a;
        }, {}) || {};

    const uniqueCreators =
        creators?.detailValues?.reduce((a: CreatorDetailValue[], b) => {
            const module = storyTellingModule?.tabs?.find(
                tab => tab?.contentHeader?.toLowerCase() === b?.displayName?.toLowerCase()
            );
            if (!module && b) {
                const { browseUrl, displayName, displayDetails, detailKey } = b;
                a.push({ browseUrl, displayName, displayDetails, detailKey });
            }
            return a;
        }, []) || [];

    return { creatorLinkMap, uniqueCreators };
};
